  <template>
  <va-card title="Search">
    <template slot="actions">
      <va-button @click="$emit('close')"> Close </va-button>
    </template>

    <div class="row align--center mb-1">
      <div class="flex xs12 sm6">
        <va-input class="ma-0" :value="searchTerm" placeholder="Search" @input="search">
          <va-icon name="fa fa-search" slot="prepend" />
        </va-input>
      </div>
    </div>

    <div v-if="loading" class="hiq-spinner-div">
      <img class="hiq-spinner" src="/assets/rpspinnerb.png" />
    </div>
    <va-data-table
      ref="datatable"
      :fields="fields"
      :data="filteredData"
      no-pagination
      no-data-label=""
      ext-link-field="__slot:extlink"
      v-if="!loading"
      style="height: 80vh; width: 70vw"
    >
      <template slot="sn" slot-scope="{rowData}">
        <router-link :to="rowData.snPath">
          <span @click="$emit('close')">{{ rowData.sn }}</span>
        </router-link>
      </template>
      <template slot="gn" slot-scope="{rowData}">
        <router-link :to="rowData.gnPath">
          <span @click="$emit('close')">{{ rowData.gn }}</span>
        </router-link>
      </template>
      <template slot="in" slot-scope="{rowData}">
        <router-link :to="rowData.inPath">
          <span @click="$emit('close')">{{ rowData.in }}</span>
        </router-link>
      </template>
    </va-data-table>

  </va-card>
</template>

<script>
import { debounce } from 'lodash'
import hiqapi from '@/hiqapi/hiqapi'

export default {
  data() {
    return {
      loading: true,
      searchTerm: null,
      listData: [], // list of currentListType
    }
  },
  computed: {
    fields() {
      return [
        { name: '__slot:sn', sortField: 'sn', title: 'Site Name' },
        { name: 'sc', sortField: 'sc', title: 'Site City' },
        { name: '__slot:gn', sortField: 'gn', title: 'Gateway Name' },
        { name: '__slot:in', sortField: 'in', title: 'Inverter Name' },
      ]
    },

    filteredData() {
      let data = this.listData

      if (!this.searchTerm || this.searchTerm.length < 2) {
        return []
      }

      return data.filter((item) => {
        var st = this.searchTerm.toLowerCase()
        // console.log(item)
        return (item.sc.toLowerCase().indexOf(st) !== -1 && item.typ === 's') ||
          // (item.sn.toLowerCase().indexOf(st) !== -1 && item.typ === 's') ||    site==gw name, so this is redundant
          (item.gn.toLowerCase().indexOf(st) !== -1 && item.typ === 'g') ||
          item.in.toLowerCase().indexOf(st) !== -1
      })
    },
  },

  methods: {
    zib() {
      console.log('ZIBZIBZIBZIBZIBZIBZIBZIBZIBZIBZIB!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!')
    },
    dialogCancel() {
      console.log('CANCEL')
    },

    setData(newval) {
      // What a mess this is!

      this.loading = false
      this.listData = []

      var siteNames = {}
      var siteCities = {}
      var gwNames = {}

      // if the site name/city matches, only show the entries at the site level, i.e. don't show all of the gws or inverters
      // if the gw name matches, only show entries with the gw name match
      // if the inv name matches <-- don't have to do anything special here

      newval.items.forEach((item) => {
        const siteId = item[1]
        if (item[0] === 's') {
          const siteName = item[2]
          const siteCity = item[3] || ''
          siteNames[siteId] = siteName
          siteCities[siteId] = siteCity
          const snPath = { name: 'dashboard_site-gws', params: { siteId: siteId, gwSerial: 0 } }
          const gnPath = ''
          const inPath = ''

          this.listData.push({ typ: 's', sn: siteName, sc: siteCity, gn: '', in: '', snPath: snPath, gnPath: gnPath, inPath: inPath })
        }

        if (item[0] === 'g') {
          const gwSerial = item[2]
          const gwName = item[3] || gwSerial.toString()
          gwNames[gwSerial] = gwName
          const snPath = { name: 'dashboard_site-gws', params: { siteId: siteId, gwSerial: 0 } }
          const gnPath = { name: 'dashboard_site-gw-invs', params: { siteId: siteId, gwSerial: gwSerial, invSerial: 0 } }
          const inPath = ''

          this.listData.push({ typ: 'g', sn: siteNames[siteId], sc: siteCities[siteId], gn: gwName, in: '', snPath: snPath, gnPath: gnPath, inPath: inPath })
        }

        if (item[0] === 'i') {
          const gwSerial = item[2]
          const invSerial = item[3]
          const invName = item[4] || invSerial.toString()
          const snPath = { name: 'dashboard_site-gws', params: { siteId: siteId, gwSerial: 0 } }
          const gnPath = { name: 'dashboard_site-gw-invs', params: { siteId: siteId, gwSerial: gwSerial, invSerial: 0 } }
          const inPath = { name: 'dashboard_site-gw-invs', params: { siteId: siteId, gwSerial: gwSerial, invSerial: invSerial } }

          this.listData.push({ typ: 'i', sn: siteNames[siteId], sc: siteCities[siteId], gn: gwNames[gwSerial], in: invName, snPath: snPath, gnPath: gnPath, inPath: inPath })
        }
      })

      // Vuetable uses "item_id" to track which row is selected and it needs to be unique
      this.listData.forEach((item) => {
        item['item_id'] = item['path']
      })

      // this.listData.sort((a, b) => {
      //   return a.serial > b.serial ? 1 : b.serial > a.serial ? -1 : 0
      // })
    },

    search: debounce(function(searchTerm) {
      this.searchTerm = searchTerm
    }, 400),

    reload() {
      this.isLoading = true
      hiqapi.getcb('/sites?search_tree=true', this.setData)
    },
  },

  mounted() {
    this.$root.$on('reload_gateway_list', (arg1, arg2) => {
      this.reload()
    })
    this.reload()
  },
}
</script>

<style lang="scss">
.font-awesome-icon {
  color: #bebebe;
}
.hiq-spinner-div {
  display: flex;
  justify-content: center;
  padding: 30px;
}
.hiq-spinner {
  animation-duration: 1.5s;
  animation-timing-function: cubic-bezier(0.54, 0.18, 0.46, 0.82);
  animation-delay: 0s;
  animation-iteration-count: infinite;
  animation-direction: normal;
  animation-fill-mode: none;
  animation-play-state: running;
  animation-name: spinner-rotation;
}
@keyframes spinner-rotation {
  from {
    -webkit-transform: rotate(0deg);
  }
  to {
    -webkit-transform: rotate(359deg);
  }
}
</style>
